import { forwardRef, useLayoutEffect, useState } from 'react'

import { UIIconType } from '@/components/UI/UIIcon'
import { useGSAP } from '@/composables/useGSAP'

import UIParticle from './UIParticle'

export type UIParticlesProps = React.HTMLProps<HTMLDivElement> & {
  max?: number
  frequency?: number
  delay?: number
  variant?: 'default' | 'small'
  exclude?: {
    colors?: string[]
    icons?: UIIconType[]
  }
  onCompleted?: () => void
}

const icons = [
    'clover',
    'diamond',
    // 'explosion',
    // 'swirl',
    'triangle',
    'circle',
    // 'doodle',
  ],
  colors = ['light-blue', 'mid-blue', 'scarlet', 'peach', 'coral']

const UIParticles = forwardRef<HTMLDivElement, UIParticlesProps>(
  (
    {
      className,
      max = 10,
      frequency = 0.03,
      delay = 0,
      variant = 'default',
      exclude = { colors: [], icons: [] },
      onCompleted,
    },
    ref
  ) => {
    const { gsap } = useGSAP()
    const [particles, setParticles] = useState<
      Array<{
        icon: UIIconType
        color: string
      }>
    >([])

    useLayoutEffect(() => {
      const ctx = gsap.context(() => {
        const timeline = gsap.timeline({
          // repeat: -1, repeatDelay: 1
          delay: delay,
          onComplete: onCompleted,
        })

        timeline.add(() => setParticles([]))
        let time = 0

        const filteredColors = colors.filter((color) => !exclude.colors?.includes(color))
        const filteredIcons = icons.filter((icon) => !exclude.icons?.includes(icon as UIIconType))

        for (let i = 0; i < max; i++) {
          time += frequency
          timeline.add(() => {
            setParticles((prev) => [
              ...prev,
              {
                icon: filteredIcons[Math.floor(Math.random() * filteredIcons.length)] as UIIconType,
                color: filteredColors[Math.floor(Math.random() * filteredColors.length)],
              },
            ])
          }, time)
        }
        timeline.add(() => setParticles([]), 1)
      })

      return () => ctx.revert()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <div
        ref={ref}
        className={`UIParticles pointer-events-none ${className ? className : 'fixed top-0 left-0 w-screen min-h-dvh md:h-screen'}`}
      >
        {particles.map((item, index) => (
          <UIParticle
            key={index}
            icon={item.icon}
            color={item.color}
            power={variant === 'default' ? 1 : 0.15}
            duration={variant === 'default' ? 0.8 : 0.5}
            className={variant === 'default' ? 'text-48 md:text-80' : 'text-16 md:text-32'}
          />
        ))}
      </div>
    )
  }
)
export default UIParticles
